import axios from "axios";
import store from "../../../redux/store";
import { handleLogout } from "../api/authApis";

export const nationalities = [
  {
    key: "JOR",
    value: "JOR",
    text: "Jordan",
    flag: "jo",
  },
  {
    key: "AFG",
    value: "AFG",
    text: "Afghanistan",
    flag: "af",
  },
  {
    key: "ALA",
    value: "ALA",
    text: "Aland Islands",
    flag: "ax",
  },
  {
    key: "ALB",
    value: "ALB",
    text: "Albania",
    flag: "al",
  },
  {
    key: "DZA",
    value: "DZA",
    text: "Algeria",
    flag: "dz",
  },
  {
    key: "ASM",
    value: "ASM",
    text: "American Samoa",
    flag: "as",
  },
  {
    key: "AND",
    value: "AND",
    text: "Andorra",
    flag: "ad",
  },
  {
    key: "AGO",
    value: "AGO",
    text: "Angola",
    flag: "ao",
  },
  {
    key: "AIA",
    value: "AIA",
    text: "Anguilla",
    flag: "ai",
  },
  {
    key: "ARG",
    value: "ARG",
    text: "Argentina",
    flag: "ar",
  },
  {
    key: "ARM",
    value: "ARM",
    text: "Armenia",
    flag: "am",
  },
  {
    key: "ABW",
    value: "ABW",
    text: "Aruba",
    flag: "aw",
  },
  {
    key: "AUS",
    value: "AUS",
    text: "Australia",
    flag: "au",
  },
  {
    key: "AUT",
    value: "AUT",
    text: "Austria",
    flag: "at",
  },
  {
    key: "AZE",
    value: "AZE",
    text: "Azerbaijan",
    flag: "az",
  },
  {
    key: "BHS",
    value: "BHS",
    text: "Bahamas",
    flag: "bs",
  },
  {
    key: "BHR",
    value: "BHR",
    text: "Bahrain",
    flag: "bh",
  },
  {
    key: "BGD",
    value: "BGD",
    text: "Bangladesh",
    flag: "bd",
  },
  {
    key: "BRB",
    value: "BRB",
    text: "Barbados",
    flag: "bb",
  },
  {
    key: "BLR",
    value: "BLR",
    text: "Belarus",
    flag: "by",
  },
  {
    key: "BEL",
    value: "BEL",
    text: "Belgium",
    flag: "be",
  },
  {
    key: "BLZ",
    value: "BLZ",
    text: "Belize",
    flag: "bz",
  },
  {
    key: "BEN",
    value: "BEN",
    text: "Benin",
    flag: "bj",
  },
  {
    key: "BMU",
    value: "BMU",
    text: "Bermuda",
    flag: "bm",
  },
  {
    key: "BTN",
    value: "BTN",
    text: "Bhutan",
    flag: "bt",
  },
  {
    key: "BOL",
    value: "BOL",
    text: "Bolivia",
    flag: "bo",
  },
  {
    key: "BIH",
    value: "BIH",
    text: "Bosnia",
    flag: "ba",
  },
  {
    key: "BWA",
    value: "BWA",
    text: "Botswana",
    flag: "bw",
  },
  {
    key: "BVT",
    value: "BVT",
    text: "Bouvet Island",
    flag: "bv",
  },
  {
    key: "BRA",
    value: "BRA",
    text: "Brazil",
    flag: "br",
  },
  {
    key: "BGR",
    value: "BGR",
    text: "Bulgaria",
    flag: "bg",
  },
  {
    key: "BFA",
    value: "BFA",
    text: "Burkina Faso",
    flag: "bf",
  },
  {
    key: "BDI",
    value: "BDI",
    text: "Burundi",
    flag: "bi",
  },
  {
    key: "KHM",
    value: "KHM",
    text: "Cambodia",
    flag: "kh",
  },
  {
    key: "CMR",
    value: "CMR",
    text: "Cameroon",
    flag: "cm",
  },
  {
    key: "CAN",
    value: "CAN",
    text: "Canada",
    flag: "ca",
  },
  {
    key: "CPV",
    value: "CPV",
    text: "Cape Verde",
    flag: "cv",
  },
  {
    key: "CYM",
    value: "CYM",
    text: "Cayman Islands",
    flag: "ky",
  },
  {
    key: "CAF",
    value: "CAF",
    text: "Central African Republic",
    flag: "cf",
  },
  {
    key: "TCD",
    value: "TCD",
    text: "Chad",
    flag: "td",
  },
  {
    key: "CHL",
    value: "CHL",
    text: "Chile",
    flag: "cl",
  },
  {
    key: "CHN",
    value: "CHN",
    text: "China",
    flag: "cn",
  },
  {
    key: "CXR",
    value: "CXR",
    text: "Christmas Island",
    flag: "cx",
  },
  {
    key: "CCK",
    value: "CCK",
    text: "Cocos (Keeling) Islands",
  },
  {
    key: "COL",
    value: "COL",
    text: "Colombia",
    flag: "co",
  },
  {
    key: "COM",
    value: "COM",
    text: "Comoros",
    flag: "km",
  },
  {
    key: "COG",
    value: "COG",
    text: "Congo",
    flag: "cd",
  },
  {
    key: "COK",
    value: "COK",
    text: "Cook Islands",
    flag: "ck",
  },
  {
    key: "CRI",
    value: "CRI",
    text: "Costa Rica",
    flag: "cr",
  },
  {
    key: "CIV",
    value: "CIV",
    text: "Cote D'Ivoire",
    flag: "ci",
  },
  {
    key: "HRV",
    value: "HRV",
    text: "Croatia",
    flag: "hr",
  },
  {
    key: "CUB",
    value: "CUB",
    text: "Cuba",
    flag: "cu",
  },
  {
    key: "CYP",
    value: "CYP",
    text: "Cyprus",
    flag: "cy",
  },
  {
    key: "CZE",
    value: "CZE",
    text: "Czech Republic",
    flag: "cz",
  },
  {
    key: "DNK",
    value: "DNK",
    text: "Denmark",
    flag: "dk",
  },
  {
    key: "DJI",
    value: "DJI",
    text: "Djibouti",
    flag: "dj",
  },
  {
    key: "DMA",
    value: "DMA",
    text: "Dominica",
    flag: "dm",
  },
  {
    key: "DOM",
    value: "DOM",
    text: "Dominican Republic",
    flag: "do",
  },
  {
    key: "ECU",
    value: "ECU",
    text: "Ecuador",
    flag: "ec",
  },
  {
    key: "EGY",
    value: "EGY",
    text: "Egypt",
    flag: "eg",
  },
  {
    key: "SLV",
    value: "SLV",
    text: "El Salvador",
    flag: "sv",
  },
  {
    key: "GNQ",
    value: "GNQ",
    text: "Equatorial Guinea",
    flag: "gq",
  },
  {
    key: "ERI",
    value: "ERI",
    text: "Eritrea",
    flag: "er",
  },
  {
    key: "EST",
    value: "EST",
    text: "Estonia",
    flag: "ee",
  },
  {
    key: "ETH",
    value: "ETH",
    text: "Ethiopia",
    flag: "et",
  },
  {
    key: "FRO",
    value: "FRO",
    text: "Faroe Islands",
    flag: "fo",
  },
  {
    key: "FJI",
    value: "FJI",
    text: "Fiji",
    flag: "fj",
  },
  {
    key: "FIN",
    value: "FIN",
    text: "Finland",
    flag: "fi",
  },
  {
    key: "FRA",
    value: "FRA",
    text: "France",
    flag: "fr",
  },
  {
    key: "GUF",
    value: "GUF",
    text: "French Guiana",
    flag: "gf",
  },
  {
    key: "PYF",
    value: "PYF",
    text: "French Polynesia",
    flag: "pf",
  },
  {
    key: "GAB",
    value: "GAB",
    text: "Gabon",
    flag: "ga",
  },
  {
    key: "GMB",
    value: "GMB",
    text: "Gambia",
    flag: "gm",
  },
  {
    key: "GEO",
    value: "GEO",
    text: "Georgia",
    flag: "ge",
  },
  {
    key: "DEU",
    value: "DEU",
    text: "Germany",
    flag: "de",
  },
  {
    key: "GHA",
    value: "GHA",
    text: "Ghana",
    flag: "gh",
  },
  {
    key: "GIB",
    value: "GIB",
    text: "Gibraltar",
    flag: "gi",
  },
  {
    key: "GRC",
    value: "GRC",
    text: "Greece",
    flag: "gr",
  },
  {
    key: "GRL",
    value: "GRL",
    text: "Greenland",
    flag: "gl",
  },
  {
    key: "GRD",
    value: "GRD",
    text: "Grenada",
    flag: "gd",
  },
  {
    key: "GLP",
    value: "GLP",
    text: "Guadeloupe",
    flag: "gp",
  },
  {
    key: "GUM",
    value: "GUM",
    text: "Guam",
    flag: "gu",
  },
  {
    key: "GTM",
    value: "GTM",
    text: "Guatemala",
    flag: "gt",
  },
  {
    key: "GIN",
    value: "GIN",
    text: "Guinea",
    flag: "gn",
  },
  {
    key: "GNB",
    value: "GNB",
    text: "Guinea-Bissau",
    flag: "gw",
  },
  {
    key: "GUY",
    value: "GUY",
    text: "Guyana",
    flag: "gy",
  },
  {
    key: "HTI",
    value: "HTI",
    text: "Haiti",
    flag: "ht",
  },
  {
    key: "HND",
    value: "HND",
    text: "Honduras",
    flag: "hn",
  },
  {
    key: "HKG",
    value: "HKG",
    text: "Hong Kong",
    flag: "hk",
  },
  {
    key: "HUN",
    value: "HUN",
    text: "Hungary",
    flag: "hu",
  },
  {
    key: "ISL",
    value: "ISL",
    text: "Iceland",
    flag: "is",
  },
  {
    key: "IND",
    value: "IND",
    text: "India",
    flag: "in",
  },
  {
    key: "IDN",
    value: "IDN",
    text: "Indonesia",
    flag: "id",
  },
  {
    key: "IRN",
    value: "IRN",
    text: "Iran",
    flag: "ir",
  },
  {
    key: "IRQ",
    value: "IRQ",
    text: "Iraq",
    flag: "iq",
  },
  {
    key: "IRL",
    value: "IRL",
    text: "Ireland",
    flag: "ie",
  },
  {
    key: "ITA",
    value: "ITA",
    text: "Italy",
    flag: "it",
  },
  {
    key: "JAM",
    value: "JAM",
    text: "Jamaica",
    flag: "jm",
  },
  {
    key: "JPN",
    value: "JPN",
    text: "Japan",
    flag: "jp",
  },
  {
    key: "KAZ",
    value: "KAZ",
    text: "Kazakhstan",
    flag: "kz",
  },
  {
    key: "KEN",
    value: "KEN",
    text: "Kenya",
    flag: "ke",
  },
  {
    key: "KIR",
    value: "KIR",
    text: "Kiribati",
    flag: "ki",
  },
  {
    key: "KWT",
    value: "KWT",
    text: "Kuwait",
    flag: "kw",
  },
  {
    key: "KGZ",
    value: "KGZ",
    text: "Kyrgyzstan",
    flag: "kg",
  },
  {
    key: "LVA",
    value: "LVA",
    text: "Latvia",
    flag: "lv",
  },
  {
    key: "LBN",
    value: "LBN",
    text: "Lebanon",
    flag: "lb",
  },
  {
    key: "LSO",
    value: "LSO",
    text: "Lesotho",
    flag: "ls",
  },
  {
    key: "LBR",
    value: "LBR",
    text: "Liberia",
    flag: "lr",
  },
  {
    key: "LBY",
    value: "LBY",
    text: "Libya",
    flag: "ly",
  },
  {
    key: "LIE",
    value: "LIE",
    text: "Liechtenstein",
    flag: "li",
  },
  {
    key: "LTU",
    value: "LTU",
    text: "Lithuania",
    flag: "lt",
  },
  {
    key: "LUX",
    value: "LUX",
    text: "Luxembourg",
    flag: "lu",
  },
  {
    key: "MKD",
    value: "MKD",
    text: "Macedonia",
    flag: "mk",
  },
  {
    key: "MDG",
    value: "MDG",
    text: "Madagascar",
    flag: "mg",
  },
  {
    key: "MWI",
    value: "MWI",
    text: "Malawi",
    flag: "mw",
  },
  {
    key: "MYS",
    value: "MYS",
    text: "Malaysia",
    flag: "my",
  },
  {
    key: "MDV",
    value: "MDV",
    text: "Maldives",
    flag: "mv",
  },
  {
    key: "MLI",
    value: "MLI",
    text: "Mali",
    flag: "ml",
  },
  {
    key: "MLT",
    value: "MLT",
    text: "Malta",
    flag: "mt",
  },
  {
    key: "MHL",
    value: "MHL",
    text: "Marshall Islands",
    flag: "mh",
  },
  {
    key: "MTQ",
    value: "MTQ",
    text: "Martinique",
    flag: "mq",
  },
  {
    key: "MRT",
    value: "MRT",
    text: "Mauritania",
    flag: "mr",
  },
  {
    key: "MUS",
    value: "MUS",
    text: "Mauritius",
    flag: "mu",
  },
  {
    key: "MYT",
    value: "MYT",
    text: "Mayotte",
    flag: "yt",
  },
  {
    key: "MEX",
    value: "MEX",
    text: "Mexico",
    flag: "mx",
  },
  {
    key: "MCO",
    value: "MCO",
    text: "Monaco",
    flag: "mc",
  },
  {
    key: "MNG",
    value: "MNG",
    text: "Mongolia",
    flag: "mn",
  },
  {
    key: "MNE",
    value: "MNE",
    text: "Montenegro",
    flag: "me",
  },
  {
    key: "MSR",
    value: "MSR",
    text: "Montserrat",
    flag: "ms",
  },
  {
    key: "MAR",
    value: "MAR",
    text: "Morocco",
    flag: "ma",
  },
  {
    key: "MOZ",
    value: "MOZ",
    text: "Mozambique",
    flag: "mz",
  },
  {
    key: "NAM",
    value: "NAM",
    text: "Namibia",
    flag: "na",
  },
  {
    key: "NRU",
    value: "NRU",
    text: "Nauru",
    flag: "nr",
  },
  {
    key: "NPL",
    value: "NPL",
    text: "Nepal",
    flag: "np",
  },
  {
    key: "NLD",
    value: "NLD",
    text: "Netherlands",
    flag: "nl",
  },
  {
    key: "NCL",
    value: "NCL",
    text: "New Caledonia",
    flag: "nc",
  },
  {
    key: "NZL",
    value: "NZL",
    text: "New Zealand",
    flag: "nz",
  },
  {
    key: "NIC",
    value: "NIC",
    text: "Nicaragua",
    flag: "ni",
  },
  {
    key: "NER",
    value: "NER",
    text: "Niger",
    flag: "ne",
  },
  {
    key: "NGA",
    value: "NGA",
    text: "Nigeria",
    flag: "ng",
  },
  {
    key: "NIU",
    value: "NIU",
    text: "Niue",
    flag: "nu",
  },
  {
    key: "NFK",
    value: "NFK",
    text: "Norfolk Island",
    flag: "nf",
  },
  {
    key: "PRK",
    value: "PRK",
    text: "North Korea",
    flag: "kp",
  },
  {
    key: "MNP",
    value: "MNP",
    text: "Northern Mariana Islands",
    flag: "mp",
  },
  {
    key: "NOR",
    value: "NOR",
    text: "Norway",
    flag: "no",
  },
  {
    key: "OMN",
    value: "OMN",
    text: "Oman",
    flag: "om",
  },
  {
    key: "PAK",
    value: "PAK",
    text: "Pakistan",
    flag: "pk",
  },
  {
    key: "PLW",
    value: "PLW",
    text: "Palau",
    flag: "pw",
  },
  {
    key: "PSE",
    value: "PSE",
    text: "Palestine",
    flag: "ps",
  },
  {
    key: "PAN",
    value: "PAN",
    text: "Panama",
    flag: "pa",
  },
  {
    key: "PRY",
    value: "PRY",
    text: "Paraguay",
    flag: "py",
  },
  {
    key: "PER",
    value: "PER",
    text: "Peru",
    flag: "pe",
  },
  {
    key: "PHL",
    value: "PHL",
    text: "Philippines",
    flag: "ph",
  },
  {
    key: "POL",
    value: "POL",
    text: "Poland",
    flag: "pl",
  },
  {
    key: "PRT",
    value: "PRT",
    text: "Portugal",
    flag: "pt",
  },
  {
    key: "PRI",
    value: "PRI",
    text: "Puerto Rico",
    flag: "pr",
  },
  {
    key: "QAT",
    value: "QAT",
    text: "Qatar",
    flag: "qa",
  },
  {
    key: "REU",
    value: "REU",
    text: "Reunion",
    flag: "re",
  },
  {
    key: "ROM",
    value: "ROM",
    text: "Romania",
    flag: "ro",
  },
  {
    key: "RUS",
    value: "RUS",
    text: "Russia",
    flag: "ru",
  },
  {
    key: "RWA",
    value: "RWA",
    text: "Rwanda",
    flag: "rw",
  },
  {
    key: "SHN",
    value: "SHN",
    text: "Saint Helena",
    flag: "sh",
  },
  {
    key: "KNA",
    value: "KNA",
    text: "Saint Kitts and Nevis",
    flag: "kn",
  },
  {
    key: "LCA",
    value: "LCA",
    text: "Saint Lucia",
    flag: "lc",
  },
  {
    key: "WSM",
    value: "WSM",
    text: "Samoa",
    flag: "ws",
  },
  {
    key: "SMR",
    value: "SMR",
    text: "San Marino",
    flag: "sm",
  },
  {
    key: "SAU",
    value: "SAU",
    text: "Saudi Arabia",
    flag: "sa",
  },
  {
    key: "SEN",
    value: "SEN",
    text: "Senegal",
    flag: "sn",
  },
  {
    key: "SRB",
    value: "SRB",
    text: "Serbia",
    flag: "cs",
  },
  {
    key: "SYC",
    value: "SYC",
    text: "Seychelles",
    flag: "sc",
  },
  {
    key: "SLE",
    value: "SLE",
    text: "Sierra Leone",
    flag: "sl",
  },
  {
    key: "SGP",
    value: "SGP",
    text: "Singapore",
    flag: "sg",
  },
  {
    key: "SVK",
    value: "SVK",
    text: "Slovakia",
    flag: "sk",
  },
  {
    key: "SVN",
    value: "SVN",
    text: "Slovenia",
    flag: "si",
  },
  {
    key: "SLB",
    value: "SLB",
    text: "Solomon Islands",
    flag: "sb",
  },
  {
    key: "SOM",
    value: "SOM",
    text: "Somalia",
    flag: "so",
  },
  {
    key: "ZAF",
    value: "ZAF",
    text: "South Africa",
    flag: "za",
  },
  {
    key: "KOR",
    value: "KOR",
    text: "South Korea",
    flag: "kr",
  },
  {
    key: "SSD",
    value: "SSD",
    text: "South Sudan",
  },
  {
    key: "ESP",
    value: "ESP",
    text: "Spain",
    flag: "es",
  },
  {
    key: "LKA",
    value: "LKA",
    text: "Sri Lanka",
    flag: "lk",
  },
  {
    key: "SDN",
    value: "SDN",
    text: "Sudan",
    flag: "sd",
  },
  {
    key: "SUR",
    value: "SUR",
    text: "Suriname",
    flag: "sr",
  },
  {
    key: "SWZ",
    value: "SWZ",
    text: "Swaziland",
    flag: "sz",
  },
  {
    key: "SWE",
    value: "SWE",
    text: "Sweden",
    flag: "se",
  },
  {
    key: "CHE",
    value: "CHE",
    text: "Switzerland",
    flag: "ch",
  },
  {
    key: "SYR",
    value: "SYR",
    text: "Syria",
    flag: "sy",
  },
  {
    key: "TWN",
    value: "TWN",
    text: "Taiwan",
    flag: "tw",
  },
  {
    key: "TJK",
    value: "TJK",
    text: "Tajikistan",
    flag: "tj",
  },
  {
    key: "TZA",
    value: "TZA",
    text: "Tanzania",
    flag: "tz",
  },
  {
    key: "THA",
    value: "THA",
    text: "Thailand",
    flag: "th",
  },
  {
    key: "TGO",
    value: "TGO",
    text: "Togo",
    flag: "tg",
  },
  {
    key: "TKL",
    value: "TKL",
    text: "Tokelau",
    flag: "tk",
  },
  {
    key: "TON",
    value: "TON",
    text: "Tonga",
    flag: "to",
  },
  {
    key: "TUN",
    value: "TUN",
    text: "Tunisia",
    flag: "tn",
  },
  {
    key: "TUR",
    value: "TUR",
    text: "Turkey",
    flag: "tr",
  },
  {
    key: "TKM",
    value: "TKM",
    text: "Turkmenistan",
    flag: "tm",
  },
  {
    key: "TUV",
    value: "TUV",
    text: "Tuvalu",
    flag: "tv",
  },
  {
    key: "UGA",
    value: "UGA",
    text: "Uganda",
    flag: "ug",
  },
  {
    key: "UKR",
    value: "UKR",
    text: "Ukraine",
    flag: "ua",
  },
  {
    key: "ARE",
    value: "ARE",
    text: "United Arab Emirates",
    flag: "ae",
  },
  {
    key: "GBR",
    value: "GBR",
    text: "United Kingdom",
    flag: "gb",
  },
  {
    key: "USA",
    value: "USA",
    text: "United States",
    flag: "us",
  },
  {
    key: "URY",
    value: "URY",
    text: "Uruguay",
    flag: "uy",
  },
  {
    key: "UZB",
    value: "UZB",
    text: "Uzbekistan",
    flag: "uz",
  },
  {
    key: "VUT",
    value: "VUT",
    text: "Vanuatu",
    flag: "vu",
  },
  {
    key: "VEN",
    value: "VEN",
    text: "Venezuela",
    flag: "ve",
  },
  {
    key: "VNM",
    value: "VNM",
    text: "Vietnam",
    flag: "vn",
  },
  {
    key: "VGB",
    value: "VGB",
    text: "Virgin Islands, British",
  },
  {
    key: "WLF",
    value: "WLF",
    text: "Wallis and Futuna",
    flag: "wf",
  },
  {
    key: "ESH",
    value: "ESH",
    text: "Western Sahara",
    flag: "eh",
  },
  {
    key: "YEM",
    value: "YEM",
    text: "Yemen",
    flag: "ye",
  },
  {
    key: "ZMB",
    value: "ZMB",
    text: "Zambia",
    flag: "zm",
  },
  {
    key: "ZWE",
    value: "ZWE",
    text: "Zimbabwe",
    flag: "zw",
  },
];

export const country_codes = [
  {
    key: "962",
    value: "962",
    text: "+962",
    flag: "jo",
  },
  {
    key: "964",
    value: "964",
    text: "+964",
    flag: "iq",
  },
];

export const currencies = [
  {
    key: "JOD",
    value: "JOD",
    text: "JOD",
  },
  {
    key: "AUD",
    value: "AUD",
    text: "AUD",
  },
  {
    key: "BWP",
    value: "BWP",
    text: "BWP",
  },
  {
    key: "GBP",
    value: "GBP",
    text: "GBP",
  },
  {
    key: "CAD",
    value: "CAD",
    text: "CAD",
  },
  {
    key: "CNY",
    value: "CNY",
    text: "CNY",
  },
  {
    key: "DKK",
    value: "DKK",
    text: "DKK",
  },
  {
    key: "EUR",
    value: "EUR",
    text: "EUR",
  },
  {
    key: "HUF",
    value: "HUF",
    text: "HUF",
  },
  {
    key: "INR",
    value: "INR",
    text: "INR",
  },
  {
    key: "IDR",
    value: "IDR",
    text: "IDR",
  },
  {
    key: "JPY",
    value: "JPY",
    text: "JPY",
  },
  {
    key: "KWD",
    value: "KWD",
    text: "KWD",
  },
  {
    key: "MYR",
    value: "MYR",
    text: "MYR",
  },
  {
    key: "NZD",
    value: "NZD",
    text: "NZD",
  },
  {
    key: "NGN",
    value: "NGN",
    text: "NGN",
  },
  {
    key: "NOK",
    value: "NOK",
    text: "NOK",
  },
  {
    key: "PKR",
    value: "PKR",
    text: "PKR",
  },
  {
    key: "PYG",
    value: "PYG",
    text: "PYG",
  },
  {
    key: "PHP",
    value: "PHP",
    text: "PHP",
  },
  {
    key: "QAR",
    value: "QAR",
    text: "QAR",
  },
  {
    key: "RWF",
    value: "RWF",
    text: "RWF",
  },
  {
    key: "SAR",
    value: "SAR",
    text: "SAR",
  },
  {
    key: "SGD",
    value: "SGD",
    text: "SGD",
  },
  {
    key: "ZAR",
    value: "ZAR",
    text: "ZAR",
  },
  {
    key: "KRW",
    value: "KRW",
    text: "KRW",
  },
  {
    key: "TZS",
    value: "TZS",
    text: "TZS",
  },
  {
    key: "THB",
    value: "THB",
    text: "THB",
  },
  {
    key: "UGX",
    value: "UGX",
    text: "UGX",
  },
  {
    key: "AED",
    value: "AED",
    text: "AED",
  },
  {
    key: "USD",
    value: "USD",
    text: "USD",
  },
];

export const currencyDecimalPlaces = {
  USD: 2,
  EUR: 2,
  GBP: 2,
  CAD: 2,
  AUD: 2,
  CHF: 2,
  CNY: 2,
  INR: 2,
  RUB: 2,
  SAR: 2,
  JPY: 0,
  KRW: 0,
  IDR: 0,
  BHD: 3,
  KWD: 3,
  JOD: 3,
  OMR: 3,
  LYD: 3,
  TND: 3,
};

const uninterceptedAxiosInstance = axios.create();
uninterceptedAxiosInstance.interceptors.request.use(
  (config) => {
    const {
      auth: { authToken },
    } = store.getState();

    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }

    return config;
  },
  (err) => Promise.reject(err)
);

uninterceptedAxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (
      error?.response?.data?.error?.message ==
        "Unauthorized user: Role mismatch." ||
      error?.response?.data?.error?.message ==
        "Unauthorized user: Invalid token." ||
      error?.response?.data?.error?.message ==
        "Unauthorized user: No token found."
    ) {
      await handleLogout();
    }
    return Promise.reject(error);
  }
);

const backend_url = process.env.REACT_APP_API_URL;
const backend_chat_url = process.env.REACT_APP_CHAT_API_URL;
const qs = require("qs");

export { uninterceptedAxiosInstance, backend_url, qs, backend_chat_url };
